import { RollbackOutlined, StopOutlined, TeamOutlined } from '@ant-design/icons';
import { useUserContext } from '@threatadvisor/react-components';
import { Button, Layout, Space, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { addSeconds } from 'date-fns';
import React, { ReactElement } from 'react';
import Countdown from 'react-countdown';

export default function NotAuthorized(props: {
  siteSubject: string;
  redirectTo: string;
}): ReactElement {
  const { siteSubject, redirectTo } = props;

  const { oidcUser } = useUserContext();

  const hasMfaSetup = oidcUser && oidcUser.amr;

  function openEmail() {
    const recipient = 'support@threatadvisor.com';
    const subject = `${siteSubject} 404 Issue`;
    const body =
      `I am trying to access a specific page on the website, but I am getting a 404 error. ` +
      `The page I am trying to access is ${window.location}. ` +
      `Can you please look into this and let me know what's causing the error and how to fix it?`;
    window.location.href = `mailto:${recipient}?cc=${oidcUser.email}&subject=${subject}&body=${body}`;
  }

  return (
    <Layout style={{ height: '100vh' }}>
      <Content
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          padding: '15px 0px 15px 15px',
          overflow: 'hidden'
        }}
      >
        <Space
          direction="horizontal"
          style={{
            height: '90%',
            width: '85%',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography.Text>
            <StopOutlined style={{ width: 100, fontSize: '75px' }} />
          </Typography.Text>
          <Space direction="vertical">
            <Typography.Title level={1} cy-test="notauthorized">
              Not Authorized
            </Typography.Title>
            <Typography.Text>You are not authorized to use this application.</Typography.Text>
            <Space direction="horizontal">
              <Typography.Text>Redirecting to login portal in:</Typography.Text>
              <Countdown
                autoStart={true}
                date={addSeconds(Date.now(), 59)}
                renderer={({ seconds }) => <Typography.Text>{seconds}</Typography.Text>}
                onComplete={() => (window.location.href = redirectTo)}
              ></Countdown>
              <Typography.Text>seconds.</Typography.Text>
            </Space>
            <Space direction="horizontal">
              {hasMfaSetup ? (
                <Button onClick={() => window.history.back()} icon={<RollbackOutlined />}>
                  Go Back
                </Button>
              ) : (
                <Button
                  onClick={() => (window.location.href = redirectTo)}
                  icon={<RollbackOutlined />}
                >
                  Login Portal
                </Button>
              )}
              <Button onClick={openEmail} icon={<TeamOutlined />}>
                Contact Support
              </Button>
            </Space>
          </Space>
        </Space>
      </Content>
    </Layout>
  );
}
